import { Itineraries } from '@/assets/global/enums/endpoints/ItinerariesEnum'

interface Ids {
  areas?: string
  version?: string
}

export const RoutesAreasObject = [
  {
    regex: /^\/itineraries\/areas\/?$/,
    title: 'Áreas Tecnológicas',
    children: [
      {
        regex: /^\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const areaId = Number(ids.areas)
          const versionId = ids.version

          const { data: areaData } =
            areaId > 0
              ? ((await useApiModified([
                  createUrl(
                    Itineraries.AREA_ID.replace('{areaId}', String(areaId)),
                    {
                      query: { versionId },
                    },
                  ),
                ])) as { data: any; response: any })
              : { data: undefined }

          return areaData?.value?.data.areaVersion.area.name
        },
        breadcrumb: true,
      },
    ],
  },
  {
    regex: /^\/itineraries\/areas\/infographic\/[\d+]+$/,
    title: 'Infográfico',
  },
]

export const RoutesAreasComponents = [
  {
    path: '/itineraries/areas/:areas/',
    component: () => import('@/pages/itineraries/areas/[id].vue'),
  },
]
